module.exports = __webpack_public_path__ + "img/lg_ring_g_skip_null_1@2x.14296665.png";